import React, {useEffect} from 'react';
import classNames from 'classnames';

export default function Laurels({className = null, ...props}) {
  return (
    <div className={classNames(`d-flex align-items-center justify-content-center`, className)}>
      <div className="px-1 px-md-4">
        <img src={require('static/ff-landing-image-header-CCAlaurel.png')} style={{maxHeight: '100px'}} />
      </div>
      <div className="px-1 px-md-4">
        <img src={require('static/ff-landing-image-header-ACFFlaurel.png')} style={{maxHeight: '100px'}} />
      </div>
      <div className="px-1 px-md-4">
        <img src={require('static/ff-landing-image-header-MFFlaurel.png')} style={{maxHeight: '100px'}} />
      </div>
      <div className="text-center px-1 px-md-4">
        <img src={require('static/ff-landing-image-header-RT.png')} style={{maxHeight: '100px'}} />
      </div>
    </div>
  );
}
